import { Union, Literal } from "runtypes";
import type { Static } from "runtypes";

export const FinancialFundamentalsType = Union(
  Literal("Cash"),
  Literal("Cost of Revenue (COR)"),
  Literal("EBITDA"),
  Literal("EBITDA Margin"),
  Literal("Revenue"),
  Literal("Gross Profit"),
  Literal("Gross Profit Margin"),
  Literal("Net Income"),
  Literal("Net Profit Margin"),
  Literal("Operating Expenses"),
  Literal("Operating Income"),
  Literal("Total Assets"),
  Literal("Book Value"),
  Literal("Earnings per Share (EPS)"),
  Literal("Gross Profit TTM"),
  Literal("Market Capitalization"),
  Literal("Operating Margin TTM"),
  Literal("PE Ratio"),
  Literal("PEG Ratio"),
  Literal("Profit Margin"),
  Literal("Return on Assets TTM"),
  Literal("Return on Equity TTM"),
  Literal("Revenue per Share TTM")
);

export type FinancialFundamentalsType = Static<typeof FinancialFundamentalsType>;
